import { type ChangeEvent, useState, type FC } from 'react'
import { useField } from 'formik'

import { normalizeImageOrientation } from '../helpers/normalizeImageOrientation.js'
import { AgreedPlacePhotoUpload } from './AgreedPlacePhotoUpload.js'

type Props = {
  name: string
}

export const AgreedPlacePhotoUploadInput: FC<Props> = ({ name }) => {
  const [photoUploadValue, setPhotoUploadValue] = useState<string>('')
  const [field, meta, helpers] = useField(name)

  const handleImageSelect = async (image: Blob) => {
    try {
      helpers.setValue(image)
    } catch (err) {
      // reason: FIXME we want this
      // eslint-disable-next-line no-console
      console.error(err)
    }
  }

  const handlePhotoUploadChange = async (event: ChangeEvent<HTMLInputElement>) => {
    helpers.setTouched(true)
    setPhotoUploadValue(event.target.value)

    const file = event?.target?.files?.[0]

    if (!file) {
      return
    }

    const normalizedImage = await normalizeImageOrientation(file)

    await handleImageSelect(normalizedImage)
  }

  const handleImageDelete = () => {
    helpers.setValue(null)
    setPhotoUploadValue('')
  }

  return (
    <AgreedPlacePhotoUpload
      value={field.value}
      error={meta.error}
      touched={meta.touched}
      photoUploadValue={photoUploadValue}
      onImageDelete={handleImageDelete}
      onPhotoUploadChange={handlePhotoUploadChange}
    />
  )
}
